import { atom } from 'jotai';
import { atomFamily } from 'jotai-family';
import { atomWithStorage } from 'jotai/utils';
import type {
  BidComparisonBid,
  BidComparisonColumn,
  BidComparisonColumnItem,
} from '@/features/bid-comparison/types';

export const createColumnDialogOpenAtom = atom(false);

export const bidComparisonCellDialogOpenAtom = atom(false);
export const selectedBidComparisonColumnAtom = atom<{
  bid: BidComparisonBid;
  column: BidComparisonColumn;
  userQuery: string;
} | null>(null);
export const bidComparisonAnalysisDialogOpenAtom = atom(false);
export const selectedBidComparisonAnalysisAtom = atom<{
  bid: BidComparisonBid;
  column: BidComparisonColumn;
} | null>(null);
export const bidComparisonAiSummaryDialogOpenAtom = atom(false);
export const selectedBidComparisonAiSummaryAtom = atom<{ title: string; summary: string } | null>(
  null,
);

export const columnOrderAtomFamily = atomFamily((sheetId: string) =>
  atomWithStorage<string[]>(`bid-comparison-column-order-${sheetId}`, []),
);

export const hiddenColumnIdsAtomFamily = atomFamily((sheetId: string) =>
  atomWithStorage<string[]>(`bid-comparison-hidden-columns-${sheetId}`, []),
);

export const createBidComparisonSheetOpenAtom = atom(false);
export const isDeleteSheetModalOpenAtom = atom(false);
export const sheetIdToDeleteAtom = atom('');

export const isDeleteColumnModalOpenAtom = atom(false);
export const columnToDeleteAtom = atom<BidComparisonColumnItem | null>(null);

export const isRenameSheetModalOpenAtom = atom(false);
export const sheetIdToRenameAtom = atom('');
export const sheetRenameValueAtom = atom('');

const lastSelectedSheetIdAtomFamily = atomFamily((storageKey: string) =>
  atomWithStorage<string | null>(storageKey, null),
);

export const isEditColumnModalOpenAtom = atom(false);
export const columnToEditAtom = atom<BidComparisonColumnItem | null>(null);

export const isTableFlippedAtomFamily = atomFamily((sheetId: string) =>
  atomWithStorage<boolean>(`bid-comparison-table-flipped-${sheetId}`, false),
);

export const bidComparisonFirstColumnWidthAtom = atomWithStorage(
  'bidComparisonFirstColumnWidth',
  296,
);

export const hiddenBidderIdsAtomFamily = atomFamily((sheetId: string) =>
  atomWithStorage<string[]>(`bid-comparison-hidden-bidders-${sheetId}`, []),
);

export const lastSelectedSheetIdAtom = ({
  workspaceId,
  procurementId,
}: {
  workspaceId: string;
  procurementId?: string;
}) =>
  lastSelectedSheetIdAtomFamily(
    procurementId
      ? `subcontractor-comparison-last-sheet-${procurementId}`
      : `bid-comparison-last-sheet-${workspaceId}`,
  );
